import { Option, TranslationFunction } from '@/types';

export const searchActions = ($t: TranslationFunction): Option[] => [
  {
    value: 'deliveryId',
    label: $t('kolliID')
  },
  {
    value: 'phoneNumber',
    label: $t('mobilePhone')
  },
  {
    value: 'ssn',
    label: $t('ssn')
  }
];

export const columns = ($t: TranslationFunction): Option[] => [
  {
    label: $t('mobilePhoneUpperCase'),
    value: 'phoneNumber'
  },
  {
    label: $t('deliveryStatusUpperCase'),
    value: 'deliveryStatus'
  },
  {
    label: $t('kolliIDUpperCase'),
    value: 'deliveryIds'
  },
  {
    label: $t('reservedUpperCase'),
    value: 'reservedTime'
  },
  {
    label: $t('includesDrugUpperCase'),
    value: 'is_drug'
  },
  {
    label: $t('narcoticsUpperCase'),
    value: 'req_ph_ssn'
  },
  {
    label: $t('assignUpperCase'),
    value: 'assign'
  }
];
